import { Avatar, Box, Dialog, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Paper, Slide, Tab, Tabs, Toolbar, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { forwardRef, useContext, useEffect, useImperativeHandle, useState } from "react";
import { BrowserView, isBrowser, isIOS, isTablet, MobileView } from "react-device-detect";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import { icon, IMAGE_RESIZE_PATH, isNullOrEmpty, STORE_BUCKET_NAME, USER_BUCKET_NAME, WEBSITE_PATH, windowPostMessage } from "../../common/common";
import { replaceAllData } from "../../common/commonJS";
import { Decrypt } from "../../common/reacte2ee";
import { ReceiverDetailsContext } from "../../contexts/receiverDetailsContext";
import { Reactions, User } from "../../models/messaging";

interface ReactionsProps {
  messageID: string;
  reactionsProp: Reactions[];
  isOpen: boolean;
  senderID: string;
  senderDetails: User;
  onUpdateReaction: any;
  onClose: any;
}

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShowReactions = ({ messageID, reactionsProp, isOpen, senderDetails, senderID, onUpdateReaction, onClose }: ReactionsProps, ref: any) => {
  const { receiverDetails } = useContext<any>(ReceiverDetailsContext);

  reactionsProp = reactionsProp.filter((el: Reactions) => el.ucnum === senderID).concat(reactionsProp.filter((el: Reactions) => el.ucnum !== senderID));
  const [reactions, setReactions] = useState<Reactions[]>(reactionsProp);
  const [mainReactions, setMainReactions] = useState<Reactions[]>(reactionsProp);
  const [dialogOpen, setDialogOpen] = useState<boolean>(isOpen);
  const [tabValue, setTabValue] = useState<number>(0);

  useImperativeHandle(ref, () => ({
    closeReactionDialog: () => {
      setDialogOpen(false);
    },
  }));

  const UpdateReactions = () => {
    if (reactions.length === 1) {
      setDialogOpen(false);
    } else {
      const updatedReactions = reactions.filter((el: Reactions) => el.ucnum !== senderID);
      setReactions(updatedReactions);
      setMainReactions(updatedReactions);
    }
    onUpdateReaction(messageID, "", null, true);
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    switch (newValue) {
      case 0:
        setReactions(mainReactions);
        break;
      case 1:
        setReactions([mainReactions[0]]);
        break;
      case 2:
        mainReactions.length > 1 ? setReactions([mainReactions[1]]) : setReactions(mainReactions);
        break;
    }
    setTabValue(newValue);
  };

  const ReactionList = () => {
    return (
      <Box className="mar-t-12" sx={{ position: "relative", height: "calc(100vh - 113px)" }}>
        <List>
          {reactions &&
            reactions.length > 0 &&
            reactions.map((m: Reactions, u: number) => {
              m.reaction = Decrypt(m.reaction);
              if (isIOS) {
                m.reaction = replaceAllData(replaceAllData(m.reaction, `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`, `srcset="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="`), `background-size: 6100% 6100%`, `object-fit: none; background-size: 6100% 6100%`);
              } else {
                m.reaction = replaceAllData(replaceAllData(replaceAllData(m.reaction, `src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="`, `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`), `srcset=""`, ""), `srcSet=""`, "");
              }
              return (
                <ListItem key={u} sx={{ paddingLeft: "0px", paddingRight: "0px", height: "72px", pointerEvents: m.ucnum === senderID ? "all" : "none" }} secondaryAction={<Box dangerouslySetInnerHTML={{ __html: replaceAllData(m.reaction, "16", "24") }}></Box>}>
                  <ListItemButton className="pad-l-r-gutter pad-t-12 pad-b-12" onClick={UpdateReactions}>
                    <ListItemAvatar>
                      {m.ucnum === senderID ? (
                        <Avatar alt={senderDetails.name} sx={{ bgcolor: senderDetails.profilePhotoColor }} src={`${IMAGE_RESIZE_PATH}${senderDetails.entityType === 2 ? STORE_BUCKET_NAME : USER_BUCKET_NAME}/${senderDetails.profilePhoto};preset=250`} />
                      ) : isNullOrEmpty(receiverDetails) || (!isNullOrEmpty(receiverDetails) && isNullOrEmpty(receiverDetails.name)) ? (
                        <Box className="box-36 bor-rad-50 bg-light-gray mdc-typography--border display-flex-justify-center">{icon({ iconName: `${receiverDetails.entityType === 2 ? "storefront" : "person"}`, iconColor: "icon-true-white" })}</Box>
                      ) : (
                        <Avatar alt={receiverDetails.name} sx={{ bgcolor: receiverDetails.profilePhotoColor }} src={`${IMAGE_RESIZE_PATH}${receiverDetails.entityType === 2 ? STORE_BUCKET_NAME : USER_BUCKET_NAME}/${receiverDetails.profilePhoto};preset=250`} />
                      )}
                    </ListItemAvatar>
                    {m.ucnum === senderID ? (
                      <ListItemText
                        className="mar-l-4"
                        sx={{ pointerEvents: "none", maxWidth: "calc(100% - 16px)", paddingRight: "16px", margin: "0px" }}
                        primary={
                          <Typography variant="subtitle1" className="text-primary" noWrap>
                            {senderDetails.displayUsername}
                          </Typography>
                        }
                        secondary={
                          <Typography variant="body2" className="text-secondary" noWrap>
                            Tap to remove
                          </Typography>
                        }
                      />
                    ) : (
                      <ListItemText
                        className="mar-l-4"
                        sx={{ pointerEvents: "none", maxWidth: "calc(100% - 16px)", paddingRight: "16px", margin: "0px" }}
                        primary={
                          <Typography variant="subtitle1" className="text-primary" noWrap>
                            {isNullOrEmpty(receiverDetails) || (!isNullOrEmpty(receiverDetails) && isNullOrEmpty(receiverDetails.name)) ? "Account not found" : receiverDetails.displayUsername}
                          </Typography>
                        }
                      />
                    )}
                  </ListItemButton>
                </ListItem>
              );
            })}
        </List>
      </Box>
    );
  };

  useEffect(() => {
    if (!dialogOpen) {
      if (!isBrowser) {
        setTimeout(() => {
          onClose();
        }, 300);
      } else {
        onClose();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogOpen]);

  useEffect(() => {
    !isBrowser && windowPostMessage({ type: "pushState", pushPage: "reaction" }, WEBSITE_PATH);
  }, []);

  return (
    <Box>
      <BrowserView>
        <Dialog id="reaction-dialog" fullScreen open={dialogOpen} TransitionComponent={Transition} PaperProps={{ sx: { boxShadow: "none" } }} sx={{ pl: isBrowser ? "17px" : 0, pr: isBrowser ? "17px" : 0, pt: isBrowser ? "17px" : 0 }} hideBackdrop>
          <Box className="mdc-typography--background-white w-per-100" sx={{ position: "relative" }}>
            <Toolbar sx={{ p: 0, pl: 3 }}>
              <Typography variant="h6" sx={{ flex: 1, textAlign: "center" }}>
                Reactions
              </Typography>
              <IconButton edge="end" sx={{ marginRight: "8px" }} onClick={() => setDialogOpen(false)}>
                {icon({ iconName: "close", iconColor: "icon-primary" })}
              </IconButton>
            </Toolbar>
            <ReactionList />
          </Box>
        </Dialog>
      </BrowserView>
      <MobileView>
        <BottomSheet
          blocking={true}
          open={dialogOpen}
          onDismiss={() => {
            !isBrowser && windowPostMessage({ type: "historyBack" }, WEBSITE_PATH);
            setDialogOpen(false);
          }}
          snapPoints={({ maxHeight }) => [(isTablet ? 0.3 : 0.4) * maxHeight]}
        >
          <Paper sx={{ padding: "8px 0", height: "230px", boxShadow: "none !important", borderRadius: "unset !important" }}>
            <Box className="flex-direction-row pad-l-r-gutter" sx={{justifyContent: "flex-start"}}>
              <Tabs value={tabValue} onChange={handleTabChange} className="reactionsTabs" sx={{ display: "inline-flex" }}>
                <Tab label={`All ${mainReactions.length}`} />
                {mainReactions.map((k, i) => {
                  k.reaction = Decrypt(k.reaction);
                  if (isIOS) {
                    k.reaction = replaceAllData(replaceAllData(k.reaction, `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=`, `srcset="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="`), `background-size: 6100% 6100%`, `object-fit: none; background-size: 6100% 6100%`);
                  } else {
                    k.reaction = replaceAllData(replaceAllData(replaceAllData(k.reaction, `src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAgMBAhS+BpQAAAAASUVORK5CYII="`, `src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="`), `srcset=""`, ""), `srcSet=""`, "");
                  }
                  return <Tab key={i} label="1" iconPosition="start" icon={<Box dangerouslySetInnerHTML={{ __html: replaceAllData(k.reaction, "16", "24") }}></Box>} />;
                })}
              </Tabs>
            </Box>
            <ReactionList />
          </Paper>
        </BottomSheet>
      </MobileView>
    </Box>
  );
};

export default forwardRef(ShowReactions);
